module.exports = "https://s91588.cdn.ngenix.net/news-frontend/_next/static/images/Refenansirovanie-6c4d7cb6bdb03b803382c61a0fd2725a.png";